<kendo-grid-numeric-filter-menu
  [column]="column"
  [filter]="filter"
  [filterService]="pctFilterService"
  [extra]="false"
>
  <kendo-filter-eq-operator></kendo-filter-eq-operator>
  <kendo-filter-after-operator></kendo-filter-after-operator>
  <kendo-filter-before-operator></kendo-filter-before-operator>
</kendo-grid-numeric-filter-menu>
